import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
var templateUrl = require('./sites.html');

class SitesController extends ComponentController {
  sites: any[];
  canCreate: boolean;

  constructor(private $state: any, private SiteService: any, private AuthService: any) {
    super();
  }

  $onInit() {
    this.canCreate = this.AuthService.hasPermission('Site', 'create');
  }

  goToSiteDetail($event, siteId) {
    this.stopProp($event);
    this.$state.go('admin.site-detail', { siteId: siteId });
  }
}

angular.module('ciApp').component('sites', {
  templateUrl: templateUrl,
  bindings: {
    sites: '<'
  },
  controller: ['$state', 'SiteService', 'AuthService', SitesController]
});



// WEBPACK FOOTER //
// ./app/admin/sites/sites.component.ts